module.exports = __webpack_public_path__ + "img/miset3.98028577.jpg";